import { Typography, TypographyProps } from "@mui/material";
import { cn } from "../../../../helpers/cn";
import React from "react";

type ListingCoachAboutWrapperProps = TypographyProps;

export const ListingCoachAboutWrapper = ({
  className,
  children,
  ...props
}: ListingCoachAboutWrapperProps) => {
  return (
    <Typography className={cn("space-y-[16px]", className)} {...props}>
      {children}
    </Typography>
  );
};
